$(".navbar-v2").removeClass("closed");
$("body").addClass("banner");
$("#mosaic-provider-react-aria-0-1").addClass("banner-offset");
var scrolling = false;
$(document).on("scroll", function () {
  scrolling = true;
});
